import { useState, useEffect } from "react";
import SimpleTable from "../../../components/atoms/table/simpleTable/simpleTable";
import { Card } from "react-bootstrap";
import SecondTabNavigation from "../../../components/organisms/SecondTabNavigation";
import ReusableModal from "../../../components/atoms/modal/ReusableModal";
import {
  getNotificationListData,
  updateNotificationListData,
} from "./NotificationApi";
import { useNotification } from "./NotificationProvider";

const tabConfig = [{ label: "Notification", path: "/notification" }];

const columns = [
  {
    header: <div>Notifications</div>,
    accessor: "message",
    align: "left",
    cell: (row) => <div>{row.message}</div>,
  },
  {
    header: <div>Date</div>,
    accessor: "createdDate",
    align: "left",
    cell: (row) => (
      <div>
        {row.createdDate ? new Date(row.createdDate).toLocaleDateString() : ""}
      </div>
    ),
  },
];

const notificationDetailsFields = [
  { label: "Company Name", key: "companyName" },
  { label: "Location", key: "locationId" },
  { label: "Select Phibro Rep", key: "phibroSalesRepName" },
  { label: "Product", key: "productTypeName", required: true },
  { label: "Unit", key: "unitName", required: true },
  { label: "Expected Level", key: "expectedLevel", required: true },
  { label: "Phibro Lot No.", key: "lotNumber" },
  { label: "Species", key: "speciesName", required: true },
  { label: "Customer Sample ID", key: "customerSampleID", required: true },
  { label: "Sample ID", key: "sampleId" },
];

export default function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [paginationData, setPaginationData] = useState({});
  const { userID } = JSON.parse(localStorage.getItem("userData")) || {};
  const { fetchUnreadCount } = useNotification();

  useEffect(() => {
    fetchNotifications();
  }, [search]);

  const handleRowClick = (row) => {
    setSelectedNotification(row);
    setShowModal(true);
  };

  const fetchNotifications = async (searchtext, currentpage = 1, size = 25) => {
    try {
      let params = {
        loggedInUserId: userID,
        PageNumber: currentpage,
        PageSize: size,
      };
      if (search) {
        params.FilterText = search;
      }
      console.log(params);
      const res = await getNotificationListData(params);
      const { totalRecords, pageNumber, pageSize, totalPages } = res;
      setPaginationData({ totalRecords, pageNumber, pageSize, totalPages });
      setNotifications(res.results || []);
    } catch (err) {
      setNotifications([]);
    }
  };

  const handleCloseModal = async () => {
    if (selectedNotification && !selectedNotification.isRead) {
      try {
        await updateNotificationListData({
          notificationId: selectedNotification.notificationId,
        });
        setNotifications((prev) =>
          prev.map((n) =>
            n.notificationId === selectedNotification.notificationId
              ? { ...n, isRead: true }
              : n
          )
        );
        await fetchUnreadCount(); // <-- update unread count in context
      } catch (error) {
        // Optionally show error toast
      }
    }
    setShowModal(false);
    setSelectedNotification(null);
  };

  return (
    <div className="p-3">
      <SecondTabNavigation tabConfig={tabConfig} />
      <div style={{ height: 30 }} />
      <div
        className="d-flex shadow-lg flex-wrap gap-3 mb-2 align-items-center p-3"
        style={{ background: "#fff", borderRadius: 8 }}
      >
        <div className="ms-auto d-flex align-items-center">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            style={{
              width: 180,
              height: 44,
              borderRadius: 5,
              border: "1px solid #bdbdbd",
              padding: "0 12px",
              fontSize: 16,
              background: "#F5F5F5",
            }}
          />
        </div>
      </div>
      <Card>
        <Card.Body style={{ padding: 0 }}>
          <SimpleTable
            columns={columns}
            data={notifications}
            showPagination
            className="default-font-styles"
            customRowRender={(row, idx) => (
              <tr
                key={row.notificationId}
                style={{ cursor: "pointer" }}
                onClick={() => handleRowClick(row)}
              >
                <td style={{ textAlign: "left", paddingLeft: 16 }}>
                  {row.message}
                </td> 
                <td style={{ textAlign: "left" }}>
                  {row.createdDate
                    ? new Date(row.createdDate).toLocaleDateString()
                    : ""}
                </td>
              </tr>
            )}
            paginationData={paginationData}
            searchValue={search}
            fetchData={fetchNotifications}
          />
        </Card.Body>
      </Card>
      <ReusableModal
        show={showModal}
        onHide={handleCloseModal}
        title="Notification Details"
        size="xl"
        buttons={[
          {
            text: "Close",
            variant: "active",
            onClick: handleCloseModal,
          },
        ]}
      >
        {selectedNotification && (
          <div className="row g-3">
            {notificationDetailsFields.map((field, idx) => (
              <div className="col-md-4" key={field.key}>
                <label className="form-label">
                  {field.label}
                  {field.required && <span style={{ color: "red" }}> *</span>}
                </label>
                <input
                  className="form-control"
                  value={selectedNotification[field.key] || ""}
                  disabled
                />
              </div>
            ))}
          </div>
        )}
      </ReusableModal>
    </div>
  );
}
